export default __webpack_public_path__ + "a2fe0d48d686ec838c0a8bf1eade0eb3.png";